import styled from 'styled-components';
import { customTextColor } from '../../../constants/CommonStyles';

export const H5New = styled.h5`
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.1px;
  ${customTextColor}
`;
